import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"inherit\" xmlns=\"http://www.w3.org/2000/svg\" id=\"list\">\n<path d=\"M5.75 3C4.24011 3 3 4.24011 3 5.75V18.25C3 19.7599 4.24011 21 5.75 21H18.25C19.7599 21 21 19.7599 21 18.25V5.75C21 4.24011 19.7599 3 18.25 3H5.75ZM5.75 4.5H18.25C18.9491 4.5 19.5 5.05089 19.5 5.75V8.5H4.5V5.75C4.5 5.05089 5.05089 4.5 5.75 4.5ZM4.5 10H19.5V14H4.5V10ZM4.5 15.5H19.5V18.25C19.5 18.9491 18.9491 19.5 18.25 19.5H5.75C5.05089 19.5 4.5 18.9491 4.5 18.25V15.5Z\" fill=\"inherit\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol